/* eslint-disable import/prefer-default-export */
const COMPANY_CONTACT_TYPES = {
  CONTACT: 'contact',
};

export { COMPANY_CONTACT_TYPES };
